import React, { useContext, useEffect, useState } from 'react'

import { DBContext } from '../../../contexts/databases'
import { CharacterContext } from '../../../contexts/character'

import Select from 'react-select'

import * as jobsID from '../../../data/jobID'

function CardSelect(props) {
	const [options, setOptions] = useState([])
	const { item_db_card, Item } = useContext(DBContext)
	const {
		job,
		inventory,
		replaceItemInInventory,
		maxRefine,
		searchAndSetOptions,
	} = useContext(CharacterContext)

	const [selectedValue, setSelectedValue] = useState([
		{
			value: 0,
			label: 'No card',
		},
	])

	const changeLastSelectedItem = props.setLastSelectedItem

	const customStyles = props.styles

	useEffect(() => {
		if (item_db_card.length > 0) {
			let newOptions = []
			newOptions.push({ value: 0, label: 'No card' })
			let filteredDB = []
			filteredDB = filterItems(item_db_card, props.Location, job)
			filteredDB.forEach((itm) => {
				newOptions.push({
					value: itm.Id,
					label: itm.Slots
						? itm.Name + '[' + itm.Slots + ']'
						: itm.Name,
				})
			})
			setOptions(newOptions)
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [item_db_card, job])
	useEffect(() => {
		if (inventory[props.Location]?.CardSlots[props.Slot]?.Type === 'Card') {
			let cardID = inventory[props.Location]?.CardSlots[props.Slot]?.ID
			searchAndSetOptions(options, cardID, setSelectedValue)
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [inventory[props.Location].CardSlots[props.Slot], options])
	//to avoid residual display of previous card
	useEffect(() => {
		if (props.isDisabled)
			setSelectedValue([
				{
					value: 0,
					label: 'No card',
				},
			])
	}, [props.isDisabled])
	// },
	// 	[inventory[props.Location]],
	// 	options,
	// )
	return (
		<Select
			menuPlacement='auto'
			styles={customStyles}
			value={selectedValue}
			isDisabled={props.isDisabled}
			onChange={(event) => {
				changeLastSelectedItem(event.value)
				let current = inventory[props.Location]
				//Create a new Item
				let newItem = new Item(
					props.Location,
					maxRefine[props.Location] > 0,
				)
				//Copy current Item
				newItem.setItem(current)
				//change refine level
				newItem.setRefine(current.refine)
				//add the new card and restore the others
				let newCard = item_db_card.find(
					(card) => card.Id === event.value,
				)
				if (!newCard)
					newCard = {
						Id: 0,
						AegisName: '0',
						Name: '',
						Type: 'Card',
						Buy: 20,
						Weight: 10,
						Locations: {},
						Flags: {},
						Script: '',
					}
				newItem.CardSlots.map((cardSlot, index) =>
					index === props.Slot
						? cardSlot.changeSlot(newCard)
						: cardSlot.changeSlot(current.CardSlots[index]),
				)
				searchAndSetOptions(options, newCard.Id, setSelectedValue)
				//apply new Item to Item slot
				replaceItemInInventory(newItem)
			}}
			className='equip'
			options={options}
		/>
	)
}

function filterItems(item_db_equip, Location, job) {
	let Location2 = Location
	if (Location === 'Right_Accessory' || Location === 'Left_Accessory')
		Location2 = 'Both_Accessory'
	let formatedBaseClassName = jobsID.getFormatedBaseClassName(job)
	let filteredDB = item_db_equip.filter(
		(eq) =>
			(eq.Locations?.[Location] || eq.Locations?.[Location2]) &&
			(!eq.Jobs || eq.Jobs?.[formatedBaseClassName]),
	)
	return filteredDB
}

export default CardSelect
